// extracted by mini-css-extract-plugin
module.exports = {"wrapMain":"Main_wrapMain__2cXUD"};